<template>
  <div class="agree-content terms">

    <h6>제 1 조 (목적)</h6>
    <p>
      본 약관은 바이엘크롭사이언스주식회사(이하 "회사")가 제공하는 고객 관리 플랫폼 팜파트너 웹사이트 서비스(이하 “서비스”) 및 관련 제반 서비스의 이용과 관련하여 회사와 회원과의 권리, 의무 및 책임사항,
      기타 필요한 사항을 규정함을 목적으로 합니다.
    </p>

    <h6>제 2 조 (용어의 정의)</h6>
    <p>
      본 약관에서 사용하는 용어의 정의는 다음과 같습니다.<br />
      1. "서비스"라 함은 구현되는 단말기(PC, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 회원이 이용할 수 있는 서비스 및 관련 제반 서비스를 의미합니다.<br />
      2. "회원"이라 함은 농가 및 농업인이며, 본 서비스 이용을 신청하고 회사가 회원으로 적합하다고 인정하는 일반 개인으로 본 약관에 동의하고 서비스의 회원 가입양식을 작성하고 ID와 비밀번호를 발급받은 사람을
      말합니다.<br />
      3. "아이디(ID)”라 함은 회원의 식별과 서비스 이용을 위하여 회사가 승인한 회원의 휴대폰 전화번호를 이용하여 서비스 로그인이 가능한 숫자 조합을 말합니다.<br />
      4. "비밀번호"라 함은 회원의 아이디로 식별되는 회원의 본인 여부를 검증하기 위하여 회원 본인이 직접 설정하여 서비스에 등록한 문자와 숫자의 조합을 의미합니다.<br />
      5. "게시물"이라 함은 회원이 서비스를 이용함에 있어 서비스상에 게시한 부호·문자·음성·음향·화상·동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.<br />
    </p>
    <br />
    <h6>제 3 조 (약관의 공지 및 효력)</h6>
    <p>
      1. 회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기 화면 또는 서비스 내에 게시하거나 연결 화면을 제공하는 방법으로 회원에게 공지합니다.<br />
      2. 회사는 회원이 본 약관의 내용에 관하여 질의 및 응답을 할 수 있도록 조치를 취합니다.<br />
      3. 회사는 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률(이하 “정보통신망법”)」 등 관련 법령에 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.<br />
      4. 회사가 약관을 개정할 경우에는 적용일자 및 개정내용, 개정사유 등을 명시하여 그 적용일자로부터 최소한 7일 이전 (회원에게 불리하거나 중대한 사항의 변경은 30일 이전)부터 그 적용일자 경과 후 상당한
      기간이 경과할 때까지 서비스 내에 공지합니다<br />
      <br />
      이 경우 개정 전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도록 표시합니다. 만약, 법령의 개정으로 인하여 긴급하게 약관을 변경하는 경우에는 효력 발생일 직전에 고지하여 드리고, 변경된 약관을
      홈페이지에 1개월 이상 게시합니다.<br />
      <br />
      회원에게 불리한 약관의 개정의 경우에는 공지 외에 일정기간 서비스 내 전자우편, 전자쪽지, 로그인 시 동의 창 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.<br />
      <br />
      • 본 조의 규정에 의하여 개정된 약관(이하 "개정약관" 이라 한다)은 원칙적으로 그 효력 발생일로부터 유효합니다. 본 약관의 개정과 관련하여 이의가 있는 회원은 회원탈퇴를 할 수 있습니다. 단, 이의가
      있음에도 불구하고 회원이 당사의 고지가 있은 후 효력 발생일까지 아무런 이의를 제기하지 않았을 경우에는 개정된 약관을 승인한 것으로 간주합니다.

    </p>
    <br />

    <h6>제 4 조 (이용계약의 성립)</h6>
    <p>
      1. 이용계약은 회원이 되고자 하는 자(이하 “가입신청자”)가 본 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 특별한 하자가 없는 한 접수한 순서대로 회사가 이러한 신청에 대하여 승낙함으로써
      성립합니다.<br />

      2. 회원가입신청 양식에 기재하는 모든 회원 정보는 실제 데이터인 것으로 간주하며 실제 정보를 입력하지 않은 회원은 법적인 보호를 받을 수 없으며, 서비스 이용의 제한을 받을 수 있습니다.<br />
    </p>

    <ul>
      <li>가) 서비스 관련설비에 여유가 없는 경우</li>
      <li>나) 기술상 지장이 있는 경우</li>
      <li>다) 기타 회사의 사정상 필요하다고 인정되는 경우</li>
      <br />
    </ul>
    <p>3. 회사는 다음 각 호의 내용에 해당하는 경우 가입신청에 대한 승낙을 제한할 수 있고, 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.<br /></p>
    <ul>
      <li>가) 실명이 아니거나 타인의 명의를 이용하여 신청한 경우</li>
      <li>나) 이용계약 신청서의 내용을 허위로 기재하여 신청한 경우</li>
      <li>다) 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청한 경우</li>
      <li>라) 부정한 용도로 서비스를 이용하고자 하는 경우</li>
      <li>마) 영리를 추구할 목적으로 서비스를 이용하고자 하는 경우</li>
      <li>바) 기타 회사가 정한 가입신청 요건이 미비된 경우</li>
      <li>사) 부적격한 회원(비의료인 등)으로 판명될 때</li>
      <br />
    </ul>
    <p>
      5. 회사가 제3항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 원칙적으로 이를 가입신청자에게 알리도록 합니다.<br />
      6. 회사는 회원에 대하여 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.<br />
      7. 회사는 가입신청 승낙을 위해 가입신청자에게 의사임을 증빙할 수 있는 별도의 자료를 요청하거나 입력된 회원정보를 기준하여 의사면허 발급여부 또는 면허정보를 외부기관을 통해 직접 조회하거나 확인요청 할 수
      있습니다.<br />
      8. 이용계약의 성립 시기는 "회사"가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.<br />

    </p>

    <br />
    <h6>제 5 조 (회원정보의 변경)</h6>
    <p>
      1. 회원은 개인정보 관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만 서비스 관리를 위해 필요한 실명, 아이디 등의 일부 정보는 수정이 불가능합니다.<br />
      2. 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에 해당 변경사항을 알려야 합니다.<br />
      3. 제2항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.<br />

    </p>
    <br />
    <h6>제 6 조 (정보보호 의무)</h6>
    <p>
      1. 회사는 “정보통신망법” 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보취급방침이 적용됩니다.<br />
      <a
        href="https://www.bayer.com/ko/kr/korea-privacy-statement">https://www.bayer.com/ko/kr/korea-privacy-statement</a>
      <br />
      2. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보취급방침이 적용되지 않습니다.<br />
      3. 회사는 회원의 정보를 보호하며 회원의 정보에 대한 허락을 받지 않는 접근을 방지하기 위해 관계법령이 요구하는 시스템 및 절차를 구현하고 준수하도록 노력합니다. <br />
      4. 회사는 관계법령이 정하는 방법과 절차에 따라 회원의 정보를 회사가 유지·관리하는 시설에 저장하고 연산 처리할 수 있습니다. <br />
      5. 회사는 회사와 회원을 보호하고, 서비스를 정상적으로 운영하기 위해 관계법령이 정하는 방법과 절차에 따라 정보를 수집할 수 있습니다.<br />
      6. 회사와 회원은 서비스이용계약의 체결 및 이행과 관련하여 알게 된 상대방의 기술정보, 영업비밀 (재배면적, 재배 작물 명 등), 세무·회계정보, 기타 사업과 관련된 정보를 본 계약의 이행을 위해서만
      사용하여야 합니다.<br />

    </p>
    <br />
    <h6>제 7 조 (회원의 아이디 및 비밀번호의 관리에 대한 의무)</h6>
    <p>
      1. 회원의 아이디와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.<br />
      2. 회사는 회원의 아이디가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 회사 및 회사의 운영자로 오인한 우려가 있는 경우, 해당 아이디의 이용을 제한할 수 있습니다.<br />
      3. 회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.<br />
      4. 제3항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.<br />

    </p>
    <br />
    <h6>제 8 조 (회원에 대한 통지)</h6>
    <p>
      1. 회사가 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소 등으로 할 수 있습니다.<br />
      2. 회사는 회원 전체에 대한 통지의 경우 7일 이상 홈페이지내 내용을 게시함으로써 제1항의 통지에 갈음할 수 있습니다.<br />

    </p>
    <br />
    <h6>제 9 조 (회사의 의무)</h6>
    <p>
      1. 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인 서비스의 제공을 위하여 최선을 다하여 노력합니다.<br />
      2. 회사는 전화, 전자우편 또는 1:1문의 링크 등의 기타 적절한 방법을 통하여 서비스이용과 관련하여 회원으로부터 제기된 의견이나 불만사항을 접수하여야 합니다. 회원으로부터 제기되는 의견이나 불만이
      객관적으로 타당하다고 판단되는 경우에는 이를 처리하여야 하며, 회원에게 처리과정 및 결과를 전달합니다.<br />
      3. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 별도로 규정한 개인정보취급방침에 따라 보안시스템을 구축하며 개인정보 보호정책을 공시하고 준수합니다.<br />

    </p>
    <br />
    <h6>제 10 조 (회원의 의무)</h6>
    <p>
      1. 회사의 명시적 동의가 없는 한 회원의 이용권한은 회원 개인에 한정되며, 타인에게 양도, 증여하거나 이를 담보로 제공할 수 없습니다.<br />
      2. 회원은 본 서비스 이용 시 다음 각 호의 행위를 할 수 없습니다.<br />

    </p>
    <ul>
      <li>가) 신청 또는 변경 시 허위 사실을 기재하거나, 다른 사람의 개인정보를 이용하는 행위</li>
      <li>나) 본 서비스 이용 중 습득한 정보를 상업적 목적으로 이용하거나 출판, 방송 등을 통하여 회사의 허락 없이 제3자에 노출시키는 행위. 단, 공익 목적이나 회원의 이익을 위하여 필요한 경우에는 회사에게
        협의를 요청하고 사전 동의를 구하도록 합니다.</li>
      <li>다) 제3자의 권리나 저작권 등을 침해하는 행위</li>
      <li>라) 서비스를 이용하여 상품 또는 용역을 판매하는 영업 활동 등의 상행위</li>
      <li>마) 해킹, 광고, 음란사이트 홍보, 소프트웨어 불법배포</li>
      <li>바) 회사의 운영진, 직원 또는 관계자를 사칭하는 행위</li>
      <li>사) 회사 또는 제3자의 명예를 손상시키는 행위</li>
      <li>아) 회사 또는 제3자의 공식적인 서비스 제공을 방해하는 행위</li>
      <li>자) 기타 불법적이거나 사회통념상 부당한 행위</li>
      <br />
    </ul>
    <p>3. 회원은 관계법, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</p>


    <br />
    <h6>제 11 조 (서비스의 제공 등)</h6>
    <p>
      1. 회사는 필요 시 회원에게 아래와 같은 새로운 서비스를 제공합니다.
    </p>
    <ul>
      <li>가) 컨텐츠 제공형 서비스 (E-Detail 등)</li>
      <li>나) 개인형 서비스 (프로필 등)</li>
      <li>다) 제휴형 서비스 (웨비나 등)</li>
      <li>라) 기타 회사가 추가 개발하거나 다른 회사와의 제휴계약 등을 통해 회원에게 제공하는 일체의 서비스</li>
      <br />
    </ul>
    <p>
      2. 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 다만 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있으며, 이러한 경우에는 그 내용을 사전에
      공지합니다.<br />
      3. 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 제8조(회원에 대한 통지)에서
      정한 방법으로 회원에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.<br />
      4. 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.<br />

    </p>
    <br />
    <h6>제 12 조 (서비스의 변경 및 중지)</h6>
    <p>
      1. 회사에서 제공하는 서비스가 아닌 의사 등 서비스 참여자 개인이 제공하는 서비스의 경우 참여자의 사정에 따라 지연, 연기, 중단 등이 될 수 있습니다.<br />
      2. 회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.<br />
      3. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전에 해당 서비스 초기화면에 게시하여야 합니다.<br />
      4. 회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지
      않습니다.<br />
      5. 서비스 중단의 경우에는 회원에게 그 사실을 사전에 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인한 서비스의 중단(운영자의 고의나 과실이 없는 시스템 장애 등)으로 인하여 사전 통지가 불가능한
      경우에는 예외로 합니다.<br />

    </p>

    <h6>제 13 조 (정보의 제공 및 광고의 게재)</h6>
    <p>
      1. 회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 고객문의 등에 대한 답변
      등을 제외하고는 언제든지 전자우편에 대해서 수신 거절을 할 수 있습니다.<br />
      2. 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 회원의 사전 동의를 받아서 전송합니다. 다만, 회원의 거래관련 정보 및 고객문의 등에 대한 회신에 있어서는 제외됩니다.<br />
      3. 회사는 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편을 수신한 회원은 수신거절을 회사에게 할 수 있습니다.<br />
      5. 이용자(회원, 비회원 포함)는 회사가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지 않습니다. 만약 회원이 개인정보를 허위로 기재하거나 제5조에서와 같이
      기재사항의 변경 의무를 소홀히 하면 회사의 중요한 통지를 받지 못할 수 있습니다.<br />

    </p>
    <br />

    <h6>제 14 조 (게시물의 저작권 등)</h6>
    <p>
      1. 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.<br />
      2. 회원이 서비스 내에 게시하는 게시물은 검색결과 내지 서비스 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우,
      회사는 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다.<br />
      3. 회원은 자신이 게시한 게시물을 회사가 국내외에서 다음 각 호의 목적으로 사용하는 것을 허락합니다.<br />

    </p>
    <ul>
      <li>가) 서비스 내에서 회원 게시물의 복제, 전송, 전시, 배포 및 우수 게시물을 서비스 화면에 노출하기 위하여 회원 게시물의 크기를 변화하거나 단순화하는 등의 방식으로 수정할 수 있습니다.</li>
      <li>나) 회사에서 운영하는 관련 사이트의 서비스 내에서 회원 게시물을 전시, 배포하는 것. 단 회원이 전시, 배포에 동의하지 아니할 경우, 회사는 관련 사이트의 서비스 내에서 당해 회원의 게시물을 전시,
        배포하지 않습니다.</li>
      <li>다) 회사의 서비스를 홍보하기 위한 목적으로 미디어, 통신사 등에게 회원 게시물 내용을 보도, 방영하게 하는 것. 단 이 경우 회사는 회원의 개별 동의 없이 미디어, 통신사 등에게 개인정보를 제공하지
        않습니다.</li>
      <br />
    </ul>
    <p>
      4. 전항의 규정에도 불구하고, 회사가 회원의 게시물을 전항 각 호에 기재된 목적 이외에 상업적 목적(예: 제3자에게 게시물을 제공하고 금전적 대가를 지급받는 경우 등)으로 사용할 경우에는 사전에 해당
      회원으로부터 동의를 얻어야 합니다. 게시물에 대한 회사의 사용 요청, 회원의 동의 및 동의 철회는 전화, 전자우편, 팩스 등 회사가 요청하는 방식에 따릅니다. 이 경우 회사는 게시물의 출처를 표시하며 게시물의
      사용에 동의한 해당 회원에게 별도의 보상을 제공합니다.<br />
      5. 회사는 회원을 보호하기 위해, 회원이 작성한 게시물에 회원의 개인정보가 포함되어 있거나, 현행법령을 위반하거나, 공서양속에 어긋날 경우 게시물의 노출을 제한할 수 있습니다.<br />
      6. 회원 탈퇴를 하거나 회원 자격을 상실한 경우에 본인 계정에 기록된 게시물은 삭제됩니다. 다만 제3자에게 의하여 스크랩, 펌, 담기 등으로 다시 게시된 게시물, 제3자에 의하여 댓글이 첨부된 게시물 등
      다른 회원의 정상적인 서비스 이용에 필요한 게시물은 삭제되지 않습니다.<br />
      7. 회사는 회사의 합병, 영업양도, 회사가 운영하는 사이트간의 통합 등의 사유로 원래의 게시물의 내용을 변경하지 않고 게시물의 게시 위치를 변경할 수 있습니다.<br />
    </p>


    <br />
    <h6>제 15 조 (권리의 귀속)</h6>
    <p>
      1. 서비스에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.<br />
      2. 회사는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 콘텐츠, 포인트 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수
      없습니다.<br />
    </p>
    <br />
    <h6>제 16 조 (포인트)</h6>
    <p>
      1. 필요시 회사는 회원을 대상으로 포인트 서비스를 제공할 수 있습니다<br />
      2. 회사는 필요시 서비스의 효율적 이용 및 운영을 위해 사전 공지 후 포인트의 일부 또는 전부를 조정할 수 있으며, 포인트는 회사가 정한 기간에 따라 주기적으로 소멸할 수 있습니다.<br />
      3. 회원이 서비스를 이용하여 회사로부터 무상으로 제공받은 포인트는 회사에서 정한 기한 내에만 이용이 가능합니다.<br />
      4. 회원이 포인트를 부당하게 취득한 증거가 있을 때에는 회사는 사전통지 없이 회원의 포인트를 삭제할 수 있으며 이와 관련하여 회원 자격을 제한할 수 있습니다. 또한 부정한 방법으로 획득한 포인트를 이용하여
      얻은 재화는 회사에 귀속되며 회원에게 법적 책임을 물을 수 있습니다. 단, 부당한 취득에는 시스템 오류를 이용하여 금전적 이득을 취한 경우를 포함합니다.<br />
      5. 회원탈퇴 또는 회원자격상실 시 포인트 잔액 여부와 상관없이 회원의 포인트는 소멸하며 타인에게 양도할 수 없습니다.<br />

    </p>
    <br />
    <h6>제 17 조 (계약해지 등)</h6>
    <p>
      1. 회원은 언제든지 회사가 제공하는 서비스 내의 회원탈퇴 기능을 통하여 탈퇴를 요청할 수 있으며, 회사는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.<br />
      2. 회원이 계약을 해지할 경우, 관련법 및 개인정보취급방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.<br />
      3. 회원이 계약을 해지하는 경우, 회원이 작성한 게시물 중 프로필 등과 같이 본인 계정에 등록된 게시물 일체는 삭제됩니다. 다만, 타인에 의해 담기, 스크랩 등이 되어 재게시되거나, 공용게시판에 등록된
      게시물 등은 삭제되지 않으니 사전에 삭제 후 탈퇴하시기 바랍니다.<br />

    </p>
    <br />
    <h6>제 18 조 (이용제한 등)</h6>
    <p>
      1. 회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 회사는 해당 회원에게 사전통지를 한 후 서비스 이용권한을 일정기간 제한하거나 이용권한을 상실 시킬 수도 있습니다. 단,
      회사가 회원의 이용권한을 상실 시키기 위해서는 사전통지를 해야 하고 회원이 이를 시정하거나 소명할 수 있는 기회를 부여해야 합니다.<br />
      2. 회사는 전항에도 불구하고, “주민등록법”을 위반한 명의도용 및 결제도용, “저작권법” 및 “컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹,
      악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 이용권한을 상실 시킬 수 있습니다. 본 항에 따른 이용권한 상실 시 해당 회원이 서비스 이용을 통해 획득한 포인트 및 기타 혜택
      등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.<br />
      3. 회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 및 개별 서비스상의 운영정책에서 정하는 바에 의합니다.<br />
      4. 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 회사는 제8조 “회원에 대한 통지” 에 따라 통지합니다.<br />
      5. 회원은 본 조에 따른 이용제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.<br />
    </p>

    <br />
    <h6>제 19 조 (손해의 부인/제한)</h6>
    <p>
      본 웹 사이트에 게시된 정보는 바이엘 최고의 지식과 능력에 따라 내부 및 외부로부터의 출처로부터 수집되었습니다. 본 웹 사이트에 포함되거나 인용된 정보는 회사, 제품과 서비스의 소개를 위한 것이라는 것에
      유의해 주십시오. 바이엘은 본 웹 사이트에 정확하며 최신의 정보를 사용하려고 합당한 노력을 할 것입니다. 하지만 그러한 정보의 완전 무결함이나 정확성을 표시하거나 보증하지는 않습니다. 특별히, 귀하는 이러한
      정보가 시대에 뒤떨어진 것일 수도 있다는 것을 아셔야 합니다. 따라서 귀하는 본 웹 사이트에서 습득하신 정보에 따르시기 전에 타당성 여부를 조회하셔야만 합니다. 우리의 조언이 있었다 하더라도, 제공된
      정보(특히, 안전이나 기술적인 정보를 포함하는 경우)에 대한 귀하의 조회나 귀하가 원하시는 과정이나 이용을 위한 적합성 여부의 조사 의무가 면제되지는 않습니다. 폐사의 제품이나 서비스에 대한 구체적인 조언이나
      설명은 폐사로 직접 연락하시기 바랍니다. 따라서 본 웹 사이트를 접속하고 이용하는 것은 본인의 책임하에 이루어지는 것에 동의하시는 것입니다. 바이엘과 본 웹 사이트를 제작하고, 출판하고, 게시한 그 누구도
      귀하의 접속 또는 접속 불능, 본 웹 사이트의 사용 및 사용 불능, 본 웹 사이트 내 정보의 의존에 따른 손해나 손상에 대한 책임을 지지 않습니다.
    </p>

    <br />
    <h6>제 20 조 제 3자 사이트</h6>
    <p>본 웹 사이트는 다른 사이트로의 링크나 참조를 제공할 수도 있습니다만, 바이엘은 그러한 사이트의 내용 자체나 내용으로 인한 손해나 손상에 대해 책임을 지지 않습니다. 다른 사이트로의 링크는 단지 본 웹
      사이트 이용자의 편의를 위해 제공됩니다.</p>

    <br />
    <h6>제 21 조 (책임제한)</h6>
    <p>
      1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.<br />
      2. 회사는 회원의 귀책사유로 인한 서비스의 이용 장애에 대하여는 책임을 지지 않습니다.<br />
      3. 회원이 회사의 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 내용에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서 회사는 책임이 면제됩니다.<br />
      4. 회사는 회원이 사이트에 저장, 게시 또는 전송한 정보, 자료, 사실의 신뢰성, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.<br />
      5. 회사는 회원 상호간 또는 회원과 제3자 간에 서비스를 매개로 발생한 물품거래 또는 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해에 관해서 회사는 책임이 면제됩니다.<br />
      6. 회원이 서비스 내에 포함되어 있는 링크를 통하여 다른 웹사이트로 옮겨갈 경우, 회사는 해당 사이트에서 제공하는 정보내용 및 이로 인한 손해 등에 대한 책임을 지지 않습니다.<br />
      7. 회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.<br />

    </p>

    <br />
    <h6>제 22 조 (준거법 및 재판관할)</h6>
    <p>1. 회사와 회원간 제기된 소송은 대한민국법을 준거법으로 합니다. <br />
      2. 회사와 회원간 발생한 분쟁에 관한 소송은 민사소송법에 따라 정합니다.<br />
      3. 해외에 주소나 거소가 있는 회원의 경우 회사와 회원간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을 관할법원으로 합니다.<br />
    </p>

    <br />
    <h6>부칙</h6>
    <p>• 1. 본 약관은 2024년 6월 1일부터 시행합니다.</p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>